export enum STOCK_ERROR {
  NOT_RELATION_PROVIDER_COMMISSION = 'NOT_RELATION_PROVIDER_COMMISION',

  IMPORT_STOCK_FILE_ERROR = 'SE001',

  // ms-inventory rechaza escribir el stock de un combo por la via generica: es
  // virtual, lo respaldan reservas de sus componentes y se arma desde la
  // seccion Combo de la pestana General (el backend incluso devuelve la ruta
  // correcta en `data.endpoint`). La pantalla ya no ofrece el formulario a un
  // combo (ver isComboProduct), asi que este rechazo es la red de seguridad
  // para los caminos que no controlamos.
  COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE = 'COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE',
}

export const PRODUCT_STOCK_ERRORS = {
  [STOCK_ERROR.IMPORT_STOCK_FILE_ERROR]: {
    description: 'stock:errors.IMPORT_STOCK_FILE_ERROR',
  },
  [STOCK_ERROR.COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE]: {
    title: 'stock:errors.COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE.title',
    description: 'stock:errors.COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE.description',
    severity: 'info',
  },
};
